const daycarStateFliter = function(input) {
  // 车辆状态0-已装车1-已发车2-已到达3-已卸车4-已交付5-装车中
    switch (input) {
      case '0':
        return '已装车'
      case '1':
        return '已装车'
      case '2':
        return '已装车'
      case '3':
        return '已卸车'
      case '4':
        return '已交付'
      case '5':
        return '受理通过'
      case '6':
        return '已装车'
      case '7':
        return '已卸车'
    }
}
let filterObj = {}
filterObj.daycarState = daycarStateFliter
export default filterObj
